import { gql } from "@apollo/client";

import { PaginationResponse } from "@regal-voice/ui";
import { Agent } from "Types/Agent";

export type GetAgentsResponse = {
    findAllAgents: PaginationResponse<Agent>;
};

export const getAgents = gql`
    query getAgents($queryParams: QueryParams!) {
        findAllAgents(queryParams: $queryParams) {
            items {
                id
                createdAt
                createdBy
                updatedAt
                updatedBy
                name
                email
                userType
            }
            total
            page
            pageSize
            hasMore
        }
    }
`;
